<template>
    <NuxtImg
        :src="imgSrc"
        class="blog-image aspect-[0.825/1] object-cover"
        sizes="240px lg:300px"
    />
</template>
<script lang="ts" setup>
interface Props {
    imgSrc?: string
    additionalClass?: string
}
withDefaults(defineProps<Props>(), {
    imgSrc: 'BQ4C3479.jpg',
    additionalClass: '',
});
</script>
<style scoped>
/* clip-path: polygon() (hexagon) removed — hard rule §3.4: no hexagonal clip-path shapes.
   Organic asymmetric border-radius used instead to preserve visual interest. */
.blog-image {
  border-radius: var(--radius-xl) var(--radius-sm) var(--radius-xl) var(--radius-sm);
}
</style>
